import script from "./ContentSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./ContentSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./ContentSkeleton.vue?vue&type=style&index=0&id=74a62d94&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74a62d94"]])

export default __exports__